import * as React from 'react';
import { StickyActionBar } from "../../../../components/sticky-action-bar/StickyActionBar"
import { PriceSummaryTotals } from "../../../../shared/models/price-summary-totals"
import { formatCurrency } from "../../../../utils/currency-formatter"

interface IProps {
    selectedTotals: PriceSummaryTotals;
}

export const CreditHoldTotalBar = (props: IProps) => {
    return (
        <StickyActionBar
            classes="flyout-large-drawer"
            showBar={true}>
            <div className="running-total-bar">
                <p className="row-label">Selected Totals</p>
                <div>
                    <p className="rollup-metric">
                        <span>Subtotal</span>
                        <span>{ formatCurrency(props.selectedTotals.subtotal) }</span>
                    </p>
                    <p className="rollup-metric">
                        <span>Freight</span>
                        <span>{ formatCurrency(props.selectedTotals.freight) }</span>
                    </p>
                    <p className="rollup-metric">
                        <span>Tax</span>
                        <span>{ formatCurrency(props.selectedTotals.tax) }</span>
                    </p>
                    <p className="rollup-metric">
                        <span>Total</span>
                        <span>{ formatCurrency(props.selectedTotals.total) }</span>
                    </p>
                </div>
            </div>
        </StickyActionBar>
    )
}